import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
  tone?: 'default' | 'inverted';
}

export default function Breadcrumb({ items, tone = 'default' }: BreadcrumbProps) {
  const base = tone === 'inverted' ? 'text-background-300' : 'text-foreground-500';
  const link = tone === 'inverted' ? 'hover:text-accent-400' : 'hover:text-primary-700';
  const currentText = tone === 'inverted' ? 'text-background-50 font-medium' : 'text-foreground-800 font-medium';

  return (
    <nav className={`flex items-center gap-1.5 text-xs md:text-sm flex-wrap ${base}`} aria-label="面包屑">
      {items.map((item, i) => (
        <span key={`${item.label}-${i}`} className="flex items-center gap-1.5">
          {item.to ? (
            <Link to={item.to} className={`${link} transition-colors`}>
              {item.label}
            </Link>
          ) : (
            <span className={currentText}>{item.label}</span>
          )}
          {i < items.length - 1 && <i className="ri-arrow-right-s-line opacity-60" aria-hidden="true"></i>}
        </span>
      ))}
    </nav>
  );
}